/** API routes for the Platform Participation Agreement — registered in ~/utils/routes.ts. */

export const TERMS_ROUTES = {
  get: '/terms/hlx-status',
  post: '/terms/accept',
};
